var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.template && _vm.template.instructions)?_c('v-alert',{attrs:{"type":"info","tile":""}},[_c('div',{staticClass:"font-weight-bold text-uppercase"},[_vm._v("\n    Template Instructions\n  ")]),_vm._v(" "),_c('div',[_vm._v("\n    "+_vm._s(_vm.template.instructions)+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }